import React from 'react';
import './CheckoutModal.css';

const CheckoutModal = ({ isOpen, onClose, onLogin, onGuestCheckout }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Giriş Yapmak İster misiniz?</h3>
                <p>Hesabınıza giriş yapabilir veya misafir olarak devam edebilirsiniz.</p>
                <div className="modal-buttons">
                    <button className="login-button" onClick={onLogin}>
                        Giriş Yap
                    </button>
                    <button className="guest-button" onClick={onGuestCheckout}>
                        Misafir Olarak Devam Et
                    </button>
                </div>
                <button className="close-button" onClick={onClose}>×</button>
            </div>
        </div>
    );
};

export default CheckoutModal; 